import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useFormik } from "formik";
import { Fragment, useEffect, useState } from "react";
import {
  BookAuthorOptions,
  BookCategoryOptions,
  BookPublicationOptions,
  BookTypeOptions,
  FacultyOptions,
  IssuedForOptions,
  LevelOptions,
  MajorSubjectOptions,
  MediumOptions,
  ProgramOptions,
  YearSemesterOptions,
} from "../../../../widgets/Options";
import {
  book_category_list,
  book_type_list,
  issued_for_list,
  item_category_list,
  lanugage_medium,
} from "../../../../widgets/json";
import { SearchBtn } from "../../../../widgets/AppBtn";
import { fetchDataFromApi } from "../../../../widgets/api";
import AppURL from "../../../../widgets/AppURL";
import SelectionBox from "../../../../widgets/SelectionBox";
import Container from "../../../../widgets/Container";

const LibraryFilterFormView = ({ onLibraryOptions, setOnBookList }) => {
  const languageOptions = MediumOptions(lanugage_medium);
  const LevelOption = LevelOptions(onLibraryOptions?.level);
  const FacultyOption = FacultyOptions(onLibraryOptions?.faculty);
  const [onProgramList, setOnProgramList] = useState([]);
  const IssuedForOption = IssuedForOptions(issued_for_list);
  const ItemCategoryOption = IssuedForOptions(item_category_list);
  const BookCategoryOption = IssuedForOptions(book_category_list);
  const BookTypeOption = BookTypeOptions(book_type_list);
  const ProgramOption = ProgramOptions(onProgramList?.program);
  const BookKindOption = BookCategoryOptions(onLibraryOptions?.book_kind);
  const authorOptions = BookAuthorOptions(onLibraryOptions?.author || []);
  const publicOptions = BookPublicationOptions(onLibraryOptions?.publisher || [])
  const year_semesterOption = YearSemesterOptions(
    onProgramList?.sem_maj_sub?.year_semester
  );
  const MajorSubjOption = MajorSubjectOptions(
    onProgramList?.sem_maj_sub?.major_subject
  );
  const initialValues = {
    fac_id: "",
    level_id: "",
    program: "",
    year_semester: "",
    major_id: "",
    issued_for: "",
    language: "",
    book_type: "",
    book_category: "",
    item_category: "",
    book_kind: "",
    book_author: "",
    book_pub: "",
  };

  const { errors, touched, values, handleBlur, handleSubmit, setFieldValue, isSubmitting } =
    useFormik({
      initialValues,
      onSubmit: async (values, action) => {
        let url = `${
          AppURL.LibraryURL +
          "library-book-search-count-total-report-list-view/?branch_id=" +
          1
        }`;
        if (values.fac_id) {
          url += `&fac_id=${values?.fac_id}`;
        }
        if (values.level_id) {
          url += `&level_id=${values.level_id}`;
        }
        if (values.program) {
          url += `&program=${values.program}`;
        }
        if (values.year_semester) {
          url += `&year_semester=${values.year_semester}`;
        }
        if (values.major_id) {
          url += `&major_id=${values.major_id}`;
        }
        if (values.language) {
          url += `&langauge=${values.language}`;
        }
        if (values.issued_for) {
          url += `&issued_for=${values.issued_for}`;
        }
        if (values?.book_type) {
          url += `&book_type=${values?.book_type}`;
        }
         if (values?.book_category) {
          url += `&book_category=${values?.book_category}`;
        }
         if (values?.item_category) {
          url += `&item_category=${values?.item_category}`;
        }
         if (values?.book_author) {
          url += `&book_author=${values?.book_author}`;
        }
         if (values?.book_pub) {
          url += `&book_pub=${values?.book_pub}`;
        }
if (values?.book_kind) {
          url += `&book_kind=${values?.book_kind}`;
        }

        
        try {
          const res = await fetchDataFromApi(url);
          setOnBookList(res);
        } catch (error) {
          console.log(error);
        }
      },
    });
  useEffect(() => {
    const FetchProgramList = async () => {
      if (values?.level_id && values?.fac_id) {
        try {
          await fetchDataFromApi(
            AppURL.AcademicsURL +
              "academic-student-program-search-fac_id-level_id/?level_id=" +
              values?.level_id +
              "&fac_id=" +
              values?.fac_id
          ).then((res) => {
            setOnProgramList((prevValues) => ({
              ...prevValues,
              program: res,
            }));
          });
        } catch (error) {
          console.log(error);
        }
      }
      if (values?.program) {
        try {
          await fetchDataFromApi(
            AppURL.AcademicsURL +
              "academic-student-year-semester-filter-list/?program_id=" +
              values?.program
          ).then((res) => {
            setOnProgramList((prevValues) => ({
              ...prevValues,
              sem_maj_sub: res,
            }));
          });
        } catch (error) {
          console.log(error);
        }
      }
    };
    FetchProgramList();
  }, [values?.level_id, values?.fac_id, values?.program]);

  return (
    <Fragment>
      <form onSubmit={handleSubmit}>
        <Container>
          <Grid container rowSpacing={1} columnSpacing={1}>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Faculty"
                value={values.fac_id}
                name="fac_id"
                options={FacultyOption}
                clear={true}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                handleBlur={handleBlur}
                touched={touched.fac_id}
                errors={errors.fac_id}
                required={false}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Level"
                value={values.level_id}
                name="level_id"
                clear={true}
                options={LevelOption}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                handleBlur={handleBlur}
                touched={touched.level_id}
                errors={errors.level_id}
                required={false}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Program"
                value={values.program}
                name="program"
                options={ProgramOption}
                clear={true}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                handleBlur={handleBlur}
                touched={touched.program}
                errors={errors.program}
                required={false}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Year Semester"
                value={values.year_semester}
                name="year_semester"
                options={year_semesterOption}
                clear={true}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                handleBlur={handleBlur}
                touched={touched.year_semester}
                errors={errors.year_semester}
                required={false}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Major Subject"
                value={values.major_id}
                name="major_id"
                options={MajorSubjOption}
                clear={true}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                handleBlur={handleBlur}
                touched={touched.major_id}
                errors={errors.major_id}
                required={false}
              />
            </Grid>
           
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="language"
                value={values.language}
                name="language"
                clear={true}
                options={languageOptions}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                handleBlur={handleBlur}
                touched={touched.language}
                errors={errors.language}
                required={false}
              />
            </Grid>

            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Book Type"
                name="book_type"
                value={values.book_type}
                options={BookTypeOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                clear={true}
                touched={touched.book_type}
                errors={errors.book_type}
                required={false}
                focus={true}
              />
            </Grid>

            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Book Category"
                name="book_category"
                value={values.book_category}
                options={BookCategoryOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                clear={true}
                touched={touched.book_category}
                errors={errors.book_category}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Item Category"
                name="item_category"
                value={values.item_category}
                options={ItemCategoryOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                clear={true}
                touched={touched.item_category}
                errors={errors.item_category}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Book Issue For"
                name="issued_for"
                options={IssuedForOption}
                value={values.issued_for}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                clear={true}
                touched={touched.issued_for}
                errors={errors.issued_for}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Book Kind"
                name="book_kind"
                value={values.book_kind}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                clear={true}
                options={BookKindOption}
                touched={touched.book_kind}
                errors={errors.book_kind}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Book Author"
                name="book_author"
                value={values.book_author}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                clear={true}
                options={authorOptions}
                touched={touched.book_author}
                errors={errors.book_author}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={2} sm={2} lg={2} md={2} xs={12}>
              <SelectionBox
                label="Book Publications"
                name="book_pub"
                value={values.book_pub}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) =>
                  setFieldValue(fieldName, data?data.value:"")
                }
                clear={true}
                options={publicOptions}
                touched={touched.book_pub}
                errors={errors.book_pub}
                required={false}
                focus={true}
              />
            </Grid>

            <Grid item xl={12} sm={12} lg={12} md={12} xs={12}>
              <div className="flex justify-end w-full mt-3">
                <SearchBtn type={"buton"} isSubmitting={isSubmitting} onClick={handleSubmit} />
              </div>
            </Grid>
          </Grid>{" "}
        </Container>
      </form>
    </Fragment>
  );
};

export default LibraryFilterFormView;
